<div class="navbar-wrapper">
  <app-nav-content (NavMobCollapse)="navMobCollapse()"></app-nav-content>
</div>
